// Přehled (statistiky, dlaždice).
// (Krok B1b: rozděleno ze src/app.js beze změny kódu; importy/exporty doplněny automaticky.)
import { appearance } from '../core/appearance.js';
import { DASHBOARD_KPI_IDS, DASHBOARD_SECTION_META, dashGroup, isDashGroupId } from '../core/dashboard-config.js';
import { SCORE_FACTORY_DEFAULT, auditTouchesWorkplace, auditWorkplaceIds, branchLabel, closedAudits, dashboardConfig, esc, fmtDateShort, isMyClosedAudit, matchesAuditGroup, scopeMine, scopeWorkplaceSet, sortedAuditTypes, sortedBranches, sortedWorkplaces, state, workplaceLabel, auditMatchesWpFilter, wpFilterMatchesId, wpFilterMatchesAny } from '../core/state.js';
import { isCorrectiveAssignedToMe } from './places.js';
import { SCORE_ZONE_SYMBOLS, auditUsesOkNok, auditUsesPercent, scorePercentColor, scorePercentZoneSymbol, scoreThresholdsForType } from './audit-runner.js';
import { allCorrectiveItems, isCorrectiveOverdue } from './corrective.js';
import { MONTH_NAMES_CS } from '../core/pdf.js';
import { allVisibleScheduleOccurrences, isMyOccurrence } from './schedule.js';

// ================= DASHBOARD =================
var OVERDUE_DAYS = 30;
function daysSince(iso){
  if(!iso) return null;
  return Math.floor((Date.now() - new Date(iso).getTime()) / 86400000);
}
// Fiskální rok začíná 1. dnem měsíce z Pravidel auditů (appSettings/fiscalYear
// {startMonth 1–12}, výchozí leden). Vrací začátek fiskálního roku, ve kterém je d.
function fiscalYearStart(d){
  var m = (typeof state.fiscalStartMonth==='number' && state.fiscalStartMonth>=1 && state.fiscalStartMonth<=12) ? state.fiscalStartMonth-1 : 0;
  var y = d.getMonth()>=m ? d.getFullYear() : d.getFullYear()-1;
  return new Date(y, m, 1);
}
function parseDay(s){ var m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(s||''); return m ? new Date(+m[1], +m[2]-1, +m[3]) : null; }
// Období Přehledu {start, end (bez), prevStart, prevEnd} nebo null (Vše).
// Srovnávací období = stejně dlouhý úsek bezprostředně před vybraným.
function dashboardPeriodWindow(f){
  f = f || {};
  var now = new Date(), period = f.period, start = null, end = now, cmp = DASH_CMP_MONTHS[period] || 0;
  if(period==='month') start = new Date(now.getFullYear(), now.getMonth(), 1);
  else if(period==='quarter') start = new Date(now.getFullYear(), Math.floor(now.getMonth()/3)*3, 1);
  else if(period==='year') start = new Date(now.getFullYear(), 0, 1);
  else if(period==='last12m') start = new Date(now.getFullYear(), now.getMonth()-11, 1);
  else if(period==='fiscal'){ start = fiscalYearStart(now); cmp = 12; }
  else if(period==='lastFiscal'){ end = fiscalYearStart(now); start = shiftMonths(end, -12); cmp = 12; }
  else if(period==='custom'){
    var from = parseDay(f.from), to = parseDay(f.to);
    if(!from && !to) return null;
    start = from || new Date(2000, 0, 1);
    end = to ? new Date(to.getFullYear(), to.getMonth(), to.getDate()+1) : now;
    if(end<=start) return null;
    var len = end.getTime() - start.getTime();
    return {start:start, end:end, prevStart:new Date(start.getTime()-len), prevEnd:start};
  }
  if(!start) return null;
  return {start:start, end:end, prevStart:shiftMonths(start, -cmp), prevEnd:shiftMonths(end, -cmp)};
}
function workplaceBranchId(wpId){
  var w = state.workplaces.get(wpId);
  return w ? (w.branchId||'') : '';
}
// Applies the global Dashboard filter bar's branch/workplace/audit-type filters
// (and, unless skipPeriod is set, its period filter) to the closed-audit list
// that every dashboard tile's numbers are computed from.
function dashboardFilteredAudits(skipPeriod){
  var f = (dashboardConfig && dashboardConfig.filter) || {};
  var win = skipPeriod ? null : dashboardPeriodWindow(f);
  var mine = scopeMine('dashboard'), wpSet = scopeWorkplaceSet('dashboard');
  return closedAudits().filter(function(e){
    var a = e[1];
    if(mine && !isMyClosedAudit(a)) return false;
    if(wpSet && !auditWorkplaceIds(a).concat((a.findings||[]).map(function(f){ return f.workplaceId; })).some(function(w){ return !!wpSet[w]; })) return false;
    if(f.branch && workplaceBranchId(a.workplaceId)!==f.branch) return false;
    if(!auditMatchesWpFilter(a, f.wp)) return false;
    if(f.type && a.auditTypeId!==f.type) return false;
    if(f.group && !matchesAuditGroup(a.auditTypeId, f.group)) return false;
    if(win){ var d = a.closedAt ? new Date(a.closedAt) : null; if(!d || d<win.start || d>=win.end) return false; }
    return true;
  });
}
function computeStatsBy(idField, nameField, entities, auditList){
  var stats = new Map();
  entities.forEach(function(e){
    stats.set(e[0], {name:(idField==='workplaceId' ? workplaceLabel(e[1]) : e[1].name), total:0, okNokTotal:0, okCount:0, lastClosedAt:null, lastOverall:null, lastOverallAt:null, ok:0, nok:0, na:0});
  });
  (auditList || closedAudits()).forEach(function(e){
    var a = e[1];
    var key = a[idField];
    if(key==null) return;
    var s = stats.get(key);
    if(!s){ s = {name:a[nameField]||'—', total:0, okNokTotal:0, okCount:0, lastClosedAt:null, lastOverall:null, lastOverallAt:null, ok:0, nok:0, na:0}; stats.set(key, s); }
    s.total++;
    if(!s.lastClosedAt || new Date(a.closedAt) > new Date(s.lastClosedAt)) s.lastClosedAt = a.closedAt;
    // OK/NOK jen z druhů auditu hodnocených OK/NOK, otázky (procenta) jen z procentních
    if(auditUsesOkNok(a)){
      s.okNokTotal++;
      if(a.summary && a.summary.overall==='OK') s.okCount++;
      if(!s.lastOverallAt || new Date(a.closedAt) > new Date(s.lastOverallAt)){
        s.lastOverallAt = a.closedAt; s.lastOverall = a.summary ? a.summary.overall : null;
      }
    }
    if(a.summary && auditUsesPercent(a)){ s.ok += a.summary.ok||0; s.nok += a.summary.nok||0; s.na += a.summary.na||0; }
  });
  return stats;
}
function computeWorkplaceStats(auditList){ return computeStatsBy('workplaceId','workplaceName', sortedWorkplaces(), auditList); }
function computeTypeStats(auditList){ return computeStatsBy('auditTypeId','auditTypeName', sortedAuditTypes(), auditList); }

function statCardHtml(key, s, opts){
  var dist = s.ok+s.nok+s.na;
  var pctOk = dist?(s.ok/dist*100):0, pctNok = dist?(s.nok/dist*100):0, pctNa = dist?(s.na/dist*100):0;
  var badge = s.lastOverall==='OK' ? '<span class="badge badge-ok">OK</span>' :
    s.lastOverall==='NOK' ? '<span class="badge badge-nok">NOK</span>' :
    '<span class="badge badge-neutral">bez auditu</span>';
  var overdueBadge = '';
  if(opts.showOverdue){
    var d = daysSince(s.lastClosedAt);
    if(d===null){ overdueBadge = ' <span class="badge badge-nok">nikdy auditováno</span>'; }
    else if(d>OVERDUE_DAYS){ overdueBadge = ' <span class="badge badge-na">po termínu · '+d+' dní</span>'; }
  }
  var itemDenom = (s.ok||0)+(s.nok||0);
  var itemScorePct = itemDenom ? Math.round(s.ok/itemDenom*100) : null;
  // A type card always belongs to one audit type, so its own color thresholds
  // apply; a workplace card can mix several audit types, so it falls back to
  // the shared global default (no single type to attribute it to).
  var scoreTh = opts.isType ? scoreThresholdsForType(key) : (state.scoreDefaults || SCORE_FACTORY_DEFAULT);
  var tag = opts.plain ? 'div' : 'button';
  return '<'+tag+' class="'+(opts.plain?'stat-row':'wp-card')+'" onclick="'+opts.onclick+'">' +
    '<div class="row1"><div><div class="name">'+esc(s.name)+'</div>' +
    '<div class="meta">'+s.total+' audit'+(s.total===1?'':(s.total>=2&&s.total<=4?'y':'ů')) +
    (s.lastClosedAt ? ' · naposledy '+fmtDateShort(s.lastClosedAt) : '') +
    (itemScorePct!=null ? ' · <span class="mono" style="font-weight:700;color:'+scorePercentColor(itemScorePct, scoreTh)+'">'+itemScorePct+' % úspěšnost otázek'+(appearance.colorblindMode?' '+scorePercentZoneSymbol(itemScorePct, scoreTh):'')+'</span>' : '') +
    '</div></div>' + badge + overdueBadge + '</div>' +
    (dist>0 ? ('<div class="dist-bar"><span class="dist-ok" style="width:'+pctOk+'%"></span>' +
      '<span class="dist-nok" style="width:'+pctNok+'%"></span>' +
      '<span class="dist-na" style="width:'+pctNa+'%"></span></div>' +
      '<div class="legend"><span><i style="background:var(--ok)"></i>OK '+s.ok+'</span>' +
      '<span><i style="background:var(--nok)"></i>NOK '+s.nok+'</span>' +
      '<span><i style="background:var(--na)"></i>N/A '+s.na+'</span></div>') : '') +
    '</'+tag+'>';
}
function worstFirst(statsMap){
  return Array.from(statsMap.entries()).sort(function(a,b){
    var pa = a[1].okNokTotal? a[1].okCount/a[1].okNokTotal : null;
    var pb = b[1].okNokTotal? b[1].okCount/b[1].okNokTotal : null;
    if(pa===null && pb===null) return a[1].name.localeCompare(b[1].name);
    if(pa===null) return 1;
    if(pb===null) return -1;
    return pa-pb;
  });
}
var MONTH_SHORT = ['led','úno','bře','dub','kvě','čvn','čvc','srp','zář','říj','lis','pro'];
function computeFailingQuestions(limit, auditList){
  var map = new Map();
  (auditList || closedAudits()).forEach(function(e){
    (e[1].answers||[]).forEach(function(ans){
      if(ans.result!=='OK' && ans.result!=='NOK') return;
      var key = ans.questionId || (ans.groupId+'|'+ans.questionText);
      var q = map.get(key);
      if(!q){ q = {text:ans.questionText, groupName:ans.groupName, total:0, nok:0}; map.set(key,q); }
      q.total++;
      if(ans.result==='NOK') q.nok++;
    });
  });
  var sorted = Array.from(map.values()).filter(function(q){ return q.nok>0; })
    .sort(function(a,b){ return b.nok-a.nok || (b.nok/b.total)-(a.nok/a.total); });
  return (limit && limit>0) ? sorted.slice(0,limit) : sorted;
}
function computeAuditorStats(auditList){
  var map = new Map();
  (auditList || closedAudits()).forEach(function(e){
    var a = e[1];
    var name = (a.auditorName||'').trim() || 'Bez jména';
    var s = map.get(name);
    if(!s){ s = {name:name, total:0, okNokTotal:0, okCount:0, nokSum:0, lastClosedAt:null}; map.set(name,s); }
    s.total++;
    if(auditUsesOkNok(a)){ s.okNokTotal++; if(a.summary && a.summary.overall==='OK') s.okCount++; }
    if(a.summary) s.nokSum += a.summary.nok||0;
    if(!s.lastClosedAt || new Date(a.closedAt) > new Date(s.lastClosedAt)) s.lastClosedAt = a.closedAt;
  });
  return Array.from(map.values()).sort(function(a,b){ return b.total-a.total; });
}

// Whether a dashboard section can appear at all right now (regardless of the
// visible/hidden setting) — shared by the real Dashboard, the Dashboard
// settings live preview, and the move-arrow logic, so all three always agree.
function dashboardSectionApplicable(id, noWorkplaces){
  if(isDashGroupId(id)) return !noWorkplaces && !!dashGroup(id);
  if(noWorkplaces && DASHBOARD_KPI_IDS.indexOf(id)<0) return false;
  if(id==='kpiPlan' && !hasActiveSchedules()) return false;
  if(id==='types' && sortedAuditTypes().length===0) return false;
  if(id==='branches' && sortedBranches().length===0) return false;
  if(id==='plan' && !hasActiveSchedules()) return false;
  return true;
}
function hasActiveSchedules(){
  var any = false;
  state.schedules.forEach(function(s){ if(s && s.active!==false) any = true; });
  return any;
}
function dashboardTileApplicable(id, ctx){
  return dashboardSectionApplicable(id, ctx.noWorkplaces);
}
function dashboardTileHeading(id){
  var g = dashGroup(id);
  if(g) return g.title || null;
  if(DASHBOARD_KPI_IDS.indexOf(id)>=0) return null;
  return DASHBOARD_SECTION_META[id] ? DASHBOARD_SECTION_META[id].label : null;
}
function dashboardLimitList(list, id){
  var n = dashboardConfig.limits[id]||0;
  return (n>0) ? list.slice(0,n) : list;
}

// ---------- pomocné výpočty statistik Přehledu ----------
// Srovnávací období: stejně dlouhý úsek bezprostředně před vybraným
// obdobím (měsíc, kvartál, rok, 12 měsíců). Pro "Vše" se nesrovnává.
var DASH_CMP_MONTHS = {month:1, quarter:3, year:12, last12m:12};
function shiftMonths(d, n){
  var y = d.getFullYear(), m = d.getMonth()+n;
  var last = new Date(y, m+1, 0).getDate();
  return new Date(y, m, Math.min(d.getDate(), last), d.getHours(), d.getMinutes(), d.getSeconds());
}
function monthKeyOf(d){ return d.getFullYear()+'-'+(d.getMonth()<9?'0':'')+(d.getMonth()+1); }
// Posledních n kalendářních měsíců včetně aktuálního, nejstarší první.
function dashMonthBuckets(n){
  var now = new Date(), out = [];
  for(var i=n-1;i>=0;i--){
    var s = new Date(now.getFullYear(), now.getMonth()-i, 1);
    out.push({key:monthKeyOf(s), month:s.getMonth(), year:s.getFullYear(), start:s, end:new Date(s.getFullYear(), s.getMonth()+1, 1)});
  }
  return out;
}
function dashTodayStart(){ var n = new Date(); return new Date(n.getFullYear(), n.getMonth(), n.getDate()); }
function auditsInRange(list, start, end){
  return list.filter(function(e){
    var t = e[1].closedAt ? new Date(e[1].closedAt) : null;
    return t && t>=start && t<end;
  });
}
function auditsByMonth(list){
  var map = {};
  list.forEach(function(e){
    if(!e[1].closedAt) return;
    var k = monthKeyOf(new Date(e[1].closedAt));
    (map[k] || (map[k] = [])).push(e);
  });
  return map;
}
// Skóre = podíl OK otázek (OK / (OK+NOK)) z auditů hodnocených procenty.
function auditsScore(list){
  var ok = 0, nok = 0;
  list.forEach(function(e){
    var a = e[1];
    if(a.summary && auditUsesPercent(a)){ ok += a.summary.ok||0; nok += a.summary.nok||0; }
  });
  return (ok+nok) ? ok/(ok+nok)*100 : null;
}
// Úspěšnost = podíl auditů s výsledkem OK (jen druhy hodnocené OK/NOK).
function auditsPassRate(list){
  var total = 0, ok = 0;
  list.forEach(function(e){
    if(!auditUsesOkNok(e[1])) return;
    total++;
    if(e[1].summary && e[1].summary.overall==='OK') ok++;
  });
  return total ? ok/total*100 : null;
}
// Kdy bylo opatření uzavřeno (Hotovo/Zrušeno) — poslední změna na
// současný stav v historii. U starých dat bez historie null.
function correctiveResolvedAt(item){
  if(item.status!=='hotovo' && item.status!=='zruseno') return null;
  // Začátek posledního úseku se stejným stavem — doplněné záznamy ke stavu
  // (stejný stav znovu) datum vyřešení neposouvají; úpravy osoby/termínu
  // (bez stavu) se přeskakují.
  var h = item.history || [], res = null;
  for(var i=h.length-1;i>=0;i--){
    var e = h[i];
    if(!e || !e.status) continue;
    if(e.status!==item.status) break;
    res = e.changedAt || res;
  }
  return res;
}
function isCorrectiveOpen(item){ return item.status!=='hotovo' && item.status!=='zruseno'; }
// Bylo opatření v čase t otevřené? Vzniká uzavřením auditu.
function correctiveOpenAt(item, t){
  var c = item.closedAt ? new Date(item.closedAt).getTime() : null;
  if(c==null || c>t) return false;
  if(isCorrectiveOpen(item)) return true;
  var r = correctiveResolvedAt(item);
  return !!r && new Date(r).getTime()>t;
}
function correctiveDueEnd(item){ return item.dueDate ? new Date(item.dueDate+'T23:59:59').getTime() : null; }
function dashDays(ms){ return Math.round(ms/86400000); }
function fmtNumCs(v, dec){ return v.toFixed(dec||0).replace('.', ','); }
function fmtPctCs(v, dec){ return v==null ? '—' : fmtNumCs(v, dec)+' %'; }
function dashPlural(n, one, few, many){ return n===1 ? one : (n>=2 && n<=4 ? few : many); }

// Builds the data every dashboard tile's content is computed from (the global
// filter bar's selection already applied). Shared by the real Dashboard and
// the Dashboard settings live preview, so both always show the same numbers.
function buildDashboardCtx(){
  var cfg = dashboardConfig;
  var noWorkplaces = sortedWorkplaces().length===0;
  var f = cfg.filter || {period:'all', branch:'', wp:'', type:'', group:''};
  var filtered = noWorkplaces ? [] : dashboardFilteredAudits();
  var filteredNoPeriod = noWorkplaces ? [] : dashboardFilteredAudits(true);
  var totalAudits = filtered.length;
  var okNokAudits = filtered.filter(function(e){ return auditUsesOkNok(e[1]); });
  var okAudits = okNokAudits.filter(function(e){ return e[1].summary && e[1].summary.overall==='OK'; }).length;
  var passRate = okNokAudits.length ? Math.round(okAudits/okNokAudits.length*100) : null;
  var wpStats = computeWorkplaceStats(filtered);
  var typeStats = computeTypeStats(filtered);
  var problemCount = 0;
  wpStats.forEach(function(s){ if(s.lastOverall==='NOK') problemCount++; });
  // Opatření podle filtrů (Moje/Vše, provozovna, pracoviště, druh) — bez
  // období; období se uplatní v jednotlivých dlaždicích.
  var items = [];
  // „Moje“ opatření = přímo přidělená mně (ne celé moje pracoviště) —
  // rozhodnutí uživatele, stejně jako seznam Opatření.
  var mineC = scopeMine('dashboard'), wpSetC = scopeWorkplaceSet('dashboard');
  allCorrectiveItems().forEach(function(item){
    if(mineC && !isCorrectiveAssignedToMe(item)) return;
    if(wpSetC && !wpSetC[item.workplaceId]) return;
    if(f.branch && workplaceBranchId(item.workplaceId)!==f.branch) return;
    if(!wpFilterMatchesId(f.wp, item.workplaceId)) return;
    if(f.type && item.auditTypeId!==f.type) return;
    if(f.group && !matchesAuditGroup(item.auditTypeId, f.group)) return;
    items.push(item);
  });
  var now = new Date();
  var win = dashboardPeriodWindow(f);
  return {cfg:cfg, noWorkplaces:noWorkplaces, f:f, filtered:filtered, filteredNoPeriod:filteredNoPeriod,
    totalAudits:totalAudits, passRate:passRate, problemCount:problemCount, wpStats:wpStats, typeStats:typeStats,
    items:items, win:win, now:now};
}
// Opatření vzniklá ve vybraném období (podle uzavření auditu).
function dashItemsInPeriod(ctx){
  if(!ctx.win) return ctx.items;
  var s = ctx.win.start.getTime(), e = ctx.win.end.getTime();
  return ctx.items.filter(function(it){ var t = it.closedAt ? new Date(it.closedAt).getTime() : NaN; return t>=s && t<e; });
}
// Barevná škála hodnocení: při filtru na druh auditu jeho vlastní, jinak
// výchozí z Pravidel auditů.
function dashScoreThresholds(ctx){
  return ctx.f.type ? scoreThresholdsForType(ctx.f.type) : (state.scoreDefaults || SCORE_FACTORY_DEFAULT);
}
function dashScoreZone(pct, th){
  if(pct==null) return 'empty';
  return pct>=th.good ? 'good' : (pct<th.bad ? 'bad' : 'warn');
}

// ---------- Plán: termíny pro statistiky ----------
// Termíny od začátku srovnávacího období (nejméně 12 měsíců zpět) do
// dvou týdnů dopředu, podle filtrů Přehledu; Moje = jsem auditor.
function dashPlanOccurrences(ctx){
  var today = dashTodayStart();
  var from = new Date(today.getFullYear(), today.getMonth()-11, 1);
  if(ctx.win && ctx.win.prevStart<from) from = new Date(ctx.win.prevStart.getFullYear(), ctx.win.prevStart.getMonth(), 1);
  var to = new Date(today.getTime()); to.setDate(to.getDate()+15);
  var f = ctx.f, mine = scopeMine('dashboard'), wpSet = scopeWorkplaceSet('dashboard');
  return allVisibleScheduleOccurrences(from, to).filter(function(o){
    if(mine && !isMyOccurrence(o)) return false;
    var oWps = o.workplaceIds || [o.workplaceId];
    if(wpSet && !oWps.some(function(w){ return !!wpSet[w]; })) return false;
    if(f.branch && workplaceBranchId(o.workplaceId)!==f.branch) return false;
    if(!wpFilterMatchesAny(f.wp, oWps)) return false;
    if(f.type && o.auditTypeId!==f.type) return false;
    if(f.group && !matchesAuditGroup(o.auditTypeId, f.group)) return false;
    return true;
  });
}
// Plnění plánu v [start, end): jen termíny, které už měly proběhnout (před dneškem).
function dashPlanStats(occ, start, end){
  var limit = Math.min(end.getTime(), dashTodayStart().getTime());
  var due = 0, done = 0;
  occ.forEach(function(o){
    var t = o.date.getTime();
    if(t<start.getTime() || t>=limit) return;
    due++;
    if(o.fulfilled) done++;
  });
  return {due:due, done:done, missed:due-done, rate: due ? done/due*100 : null};
}
function dashPlanWindow(ctx){
  if(ctx.win) return {start:ctx.win.start, end:(ctx.win.end<ctx.now ? ctx.win.end : ctx.now), prevStart:ctx.win.prevStart, prevEnd:ctx.win.prevEnd};
  var today = dashTodayStart();
  return {start:new Date(today.getFullYear(), today.getMonth()-11, 1), end:ctx.now, prevStart:null, prevEnd:null, implicit:true};
}
// Vyřešená opatření (Hotovo) v [start, end): v termínu / se zpožděním, doba řešení.
function dashDisciplineStats(items, start, end){
  var resolved = 0, withDue = 0, onTime = 0, lateDaysSum = 0, durSum = 0, durCount = 0;
  items.forEach(function(it){
    if(it.status!=='hotovo') return;
    var r = correctiveResolvedAt(it);
    if(!r) return;
    var rt = new Date(r).getTime();
    if(start && rt<start.getTime()) return;
    if(end && rt>=end.getTime()) return;
    resolved++;
    if(it.closedAt){ durSum += Math.max(0, rt-new Date(it.closedAt).getTime()); durCount++; }
    var due = correctiveDueEnd(it);
    if(due!=null){
      withDue++;
      if(rt<=due) onTime++; else lateDaysSum += Math.max(1, Math.ceil((rt-due)/86400000));
    }
  });
  return {resolved:resolved, withDue:withDue, onTime:onTime, late:withDue-onTime,
    onTimeRate: withDue ? onTime/withDue*100 : null,
    avgLateDays: (withDue-onTime) ? lateDaysSum/(withDue-onTime) : null,
    avgDays: durCount ? durSum/durCount/86400000 : null};
}

// ---------- grafické prvky ----------
// Křivka v malém grafu; hodnoty null přeruší čáru.
function sparkHtml(vals){
  var nums = vals.filter(function(v){ return v!=null; });
  if(nums.length<2) return '<div class="kpi-spark"></div>';
  var mn = Math.min.apply(null, nums), mx = Math.max.apply(null, nums);
  var n = vals.length, segs = [], cur = [];
  vals.forEach(function(v, i){
    if(v==null){ if(cur.length) segs.push(cur); cur = []; return; }
    var x = n>1 ? i/(n-1)*100 : 50;
    var y = 26 - (mx>mn ? (v-mn)/(mx-mn)*22 : 11);
    cur.push(x.toFixed(1)+','+y.toFixed(1));
  });
  if(cur.length) segs.push(cur);
  return '<svg class="kpi-spark" viewBox="0 0 100 28" preserveAspectRatio="none" aria-hidden="true">' +
    segs.map(function(sg){
      return sg.length>1 ? '<polyline points="'+sg.join(' ')+'"/>' : '';
    }).join('') + '</svg>';
}
// Změna proti předchozímu období. kind 'rel' = v %, 'pts' = v procentních bodech, 'abs' = rozdíl počtu.
function kpiDeltaHtml(cur, prev, kind, upIsGood){
  if(cur==null || prev==null) return '';
  var diff, txt;
  if(kind==='rel'){
    if(!prev) return '';
    diff = Math.round((cur-prev)/prev*100); txt = Math.abs(diff)+' %';
  } else if(kind==='pts'){
    diff = Math.round((cur-prev)*10)/10; txt = fmtNumCs(Math.abs(diff), Math.abs(diff)%1 ? 1 : 0)+' b.';
  } else {
    diff = cur-prev; txt = String(Math.abs(diff));
  }
  if(diff===0) return '<span class="kpi-delta">= beze změny</span>';
  var good = (diff>0)===upIsGood;
  return '<span class="kpi-delta '+(good?'good':'bad')+'" title="Změna proti předchozímu období">'+(diff>0?'↑':'↓')+' '+txt+'</span>';
}
function kpiHtml(o){
  var tag = o.onclick ? 'button' : 'div';
  return '<'+tag+(o.onclick?' type="button" onclick="'+o.onclick+'"':'')+' class="kpi">' +
    '<span class="kpi-lbl">'+esc(o.label)+'</span>' +
    '<span class="kpi-row"><span class="kpi-num mono"'+(o.numColor?' style="color:'+o.numColor+'"':'')+'>'+o.value+'</span>'+(o.delta||'')+'</span>' +
    sparkHtml(o.spark||[]) +
    '<span class="kpi-sub'+(o.subBad?' bad':'')+'">'+o.sub+'</span></'+tag+'>';
}
// Prstencový graf: parts = [{value, color}], uprostřed text.
function donutHtml(parts, centerNum, centerLbl, size){
  var total = parts.reduce(function(s,p){ return s+p.value; }, 0);
  var r = 42, C = 2*Math.PI*r, off = 0;
  var html = '<svg class="donut" viewBox="0 0 110 110" style="width:'+(size||112)+'px;height:'+(size||112)+'px" role="img" aria-label="'+esc(centerLbl+' '+centerNum)+'">' +
    '<circle cx="55" cy="55" r="'+r+'" fill="none" style="stroke:var(--border)" stroke-width="14" opacity=".45"/>' +
    '<g transform="rotate(-90 55 55)">';
  if(total>0) parts.forEach(function(p){
    if(!p.value) return;
    var L = C*p.value/total;
    html += '<circle cx="55" cy="55" r="'+r+'" fill="none" style="stroke:'+p.color+'" stroke-width="14" stroke-dasharray="'+L.toFixed(2)+' '+(C-L).toFixed(2)+'" stroke-dashoffset="'+(-off).toFixed(2)+'"/>';
    off += L;
  });
  html += '</g><text x="55" y="56" text-anchor="middle" class="donut-num">'+esc(String(centerNum))+'</text>' +
    '<text x="55" y="71" text-anchor="middle" class="donut-lbl">'+esc(centerLbl)+'</text></svg>';
  return html;
}
function dashEmptyHtml(txt){ return '<div class="muted" style="font-size:var(--fs-base)">'+esc(txt)+'</div>'; }
function jsArg(s){ return "decodeURIComponent('"+encodeURIComponent(s).replace(/'/g,'%27')+"')"; }

// ---------- jednotlivé dlaždice ----------
// Ukazatele (malé dlaždice kpi*): data se spočítají jednou za překreslení
// pro všechny a každá dlaždice vykreslí svůj.
function dashKpiTileHtml(id, ctx){
  var k = ctx._kpis || (ctx._kpis = dashKpisData(ctx));
  return k[id] ? kpiHtml(k[id]) : '';
}
// Ukazatele skupiny, které se dají zobrazit (např. Plnění plánu jen s plány).
function dashGroupMembers(id, ctx){
  var g = dashGroup(id);
  return g ? g.items.filter(function(k){ return dashboardSectionApplicable(k, ctx.noWorkplaces); }) : [];
}
function dashGroupBodyHtml(id, ctx){
  var members = dashGroupMembers(id, ctx);
  if(!members.length) return '<div class="muted" style="font-size:var(--fs-base)">Prázdná skupina — přidejte ukazatele v Upravit dashboard.</div>';
  return '<div class="kpi-group">' + members.map(function(k){ return dashKpiTileHtml(k, ctx); }).join('') + '</div>';
}
function dashKpisData(ctx){
  var out = {};
  var win = ctx.win;
  var months = dashMonthBuckets(12);
  var byMonth = auditsByMonth(ctx.filteredNoPeriod);
  var prevAudits = win ? auditsInRange(ctx.filteredNoPeriod, win.prevStart, win.prevEnd) : null;

  out.kpiAudits = ({label:'Uzavřené audity', value:String(ctx.totalAudits),
    delta: win ? kpiDeltaHtml(ctx.totalAudits, prevAudits.length, 'rel', true) : '',
    spark: months.map(function(m){ return (byMonth[m.key]||[]).length; }),
    sub: win ? 'předtím '+prevAudits.length : 'za celé období', onclick:"App.setView('history')"});

  var pass = auditsPassRate(ctx.filtered);
  out.kpiPass = ({label:'Audity bez závad', value: pass==null ? '—' : fmtPctCs(pass, 0),
    delta: win ? kpiDeltaHtml(pass==null?null:Math.round(pass), (function(v){ return v==null?null:Math.round(v); })(auditsPassRate(prevAudits)), 'pts', true) : '',
    spark: months.map(function(m){ return auditsPassRate(byMonth[m.key]||[]); }),
    sub:'podíl auditů s výsledkem OK'});

  var score = auditsScore(ctx.filtered);
  out.kpiScore = ({label:'Skóre', value: fmtPctCs(score, 1),
    numColor: score==null ? '' : scorePercentColor(Math.round(score), dashScoreThresholds(ctx)),
    delta: win ? kpiDeltaHtml(score==null?null:Math.round(score*10)/10, (function(v){ return v==null?null:Math.round(v*10)/10; })(auditsScore(prevAudits)), 'pts', true) : '',
    spark: months.map(function(m){ return auditsScore(byMonth[m.key]||[]); }),
    sub:'podíl otázek hodnocených OK'});

  var openNow = ctx.items.filter(isCorrectiveOpen);
  var overdueNow = openNow.filter(isCorrectiveOverdue).length;
  var prevOpen = win ? ctx.items.filter(function(it){ return correctiveOpenAt(it, win.prevEnd.getTime()); }).length : null;
  out.kpiOpen = ({label:'Otevřená opatření', value:String(openNow.length),
    delta: win ? kpiDeltaHtml(openNow.length, prevOpen, 'abs', false) : '',
    spark: months.map(function(m, i){
      var t = i===months.length-1 ? ctx.now.getTime() : m.end.getTime();
      return ctx.items.filter(function(it){ return correctiveOpenAt(it, t); }).length;
    }),
    sub: overdueNow ? 'z toho '+overdueNow+' po termínu' : 'žádné po termínu', subBad: overdueNow>0,
    onclick:"App.dashOpenCorrective('v_reseni')"});
  // Jen pro obrazovku Dnes (mobil) — na Přehledu je to podtitulek Otevřených opatření.
  out.kpiOverdue = ({label:'Opatření po termínu', value:String(overdueNow), numColor: overdueNow>0 ? 'var(--nok)' : '',
    sub: overdueNow>0 ? 'nevyřešená po termínu — klepněte' : 'vše v termínu', subBad: overdueNow>0,
    onclick:"App.dashOpenCorrective('overdue')"});

  if(hasActiveSchedules()){
    var occ = dashPlanOccurrences(ctx), pw = dashPlanWindow(ctx);
    var ps = dashPlanStats(occ, pw.start, pw.end);
    var prevPs = pw.prevStart ? dashPlanStats(occ, pw.prevStart, pw.prevEnd) : null;
    out.kpiPlan = ({label:'Plnění plánu', value: fmtPctCs(ps.rate, 0),
      delta: prevPs ? kpiDeltaHtml(ps.rate==null?null:Math.round(ps.rate), prevPs.rate==null?null:Math.round(prevPs.rate), 'pts', true) : '',
      spark: months.map(function(m){ return dashPlanStats(occ, m.start, m.end).rate; }),
      sub: ps.due ? ps.done+' z '+ps.due+' termínů' : 'zatím žádné termíny', onclick:"App.setView('schedule')"});
  }

  var ds = win ? dashDisciplineStats(ctx.items, win.start, win.end) : dashDisciplineStats(ctx.items, null, null);
  var prevDs = win ? dashDisciplineStats(ctx.items, win.prevStart, win.prevEnd) : null;
  out.kpiOnTime = ({label:'Opatření v termínu', value: fmtPctCs(ds.onTimeRate, 0),
    delta: prevDs ? kpiDeltaHtml(ds.onTimeRate==null?null:Math.round(ds.onTimeRate), prevDs.onTimeRate==null?null:Math.round(prevDs.onTimeRate), 'pts', true) : '',
    spark: months.map(function(m){ return dashDisciplineStats(ctx.items, m.start, m.end).onTimeRate; }),
    sub: ds.withDue ? ds.onTime+' z '+ds.withDue+' vyřešených' : 'zatím nic vyřešeno'});

  return out;
}

function dashTrendHtml(ctx){
  var n = ctx.cfg.limits.trend || 12;
  var months = dashMonthBuckets(n);
  var byMonth = auditsByMonth(ctx.filteredNoPeriod);
  var data = months.map(function(m){
    var list = byMonth[m.key] || [];
    var ok = 0, nok = 0;
    list.forEach(function(e){ if(auditUsesOkNok(e[1])){ if(e[1].summary && e[1].summary.overall==='OK') ok++; else nok++; } });
    return {m:m, total:list.length, ok:ok, nok:nok, other:list.length-ok-nok, score:auditsScore(list), pass:auditsPassRate(list)};
  });
  if(!data.some(function(d){ return d.total>0; })) return dashEmptyHtml('Za '+n+' měsíců žádné uzavřené audity.');
  var maxCount = Math.max.apply(null, data.map(function(d){ return d.total; })) || 1;
  var vals = [];
  data.forEach(function(d){ if(d.score!=null) vals.push(d.score); if(d.pass!=null) vals.push(d.pass); });
  var lowest = vals.length ? Math.min.apply(null, vals) : 100;
  var min = lowest>=55 ? 50 : Math.max(0, Math.floor((lowest-5)/10)*10);
  function yOf(v){ return 100 - (v-min)/(100-min)*100; }
  function line(key){
    var segs = [], cur = [];
    data.forEach(function(d, i){
      var v = d[key];
      if(v==null){ if(cur.length) segs.push(cur); cur = []; return; }
      cur.push(((i+.5)*10).toFixed(1)+','+yOf(v).toFixed(1));
    });
    if(cur.length) segs.push(cur);
    return segs.map(function(sg){ return sg.length>1 ? '<polyline class="qc-line-'+key+'" points="'+sg.join(' ')+'"/>' : ''; }).join('');
  }
  var pick = state.dashTrendPick;
  if(pick==null || pick>=data.length){
    pick = data.length-1;
    while(pick>0 && !data[pick].total) pick--;
  }
  var html = '<div class="qc"><div class="qc-axis"><span>100 %</span><span>'+((100+min)/2)+' %</span><span>'+min+' %</span></div>' +
    '<div class="qc-area"><div class="qc-grid" style="top:0"></div><div class="qc-grid" style="top:50%"></div><div class="qc-grid qc-grid-base" style="top:100%"></div>' +
    '<div class="qc-cols">';
  data.forEach(function(d, i){
    var h = d.total/maxCount*55;
    html += '<button type="button" class="qc-col'+(i===pick?' on':'')+'" onclick="App.dashPickTrend('+i+')" aria-label="'+esc(MONTH_NAMES_CS[d.m.month]+' '+d.m.year)+'">' +
      '<span class="qc-bar" style="height:'+h.toFixed(1)+'%">' +
      (d.total ? '<span class="qc-seg-nok" style="flex:'+d.nok+'"></span><span class="qc-seg-other" style="flex:'+d.other+'"></span><span class="qc-seg-ok" style="flex:'+d.ok+'"></span>' : '') +
      '</span></button>';
  });
  html += '</div><svg class="qc-lines" viewBox="0 0 '+(data.length*10)+' 100" preserveAspectRatio="none" aria-hidden="true">'+line('score')+line('pass')+'</svg>';
  var pd = data[pick];
  var left = ((pick+.5)/data.length*100).toFixed(2)+'%';
  if(pd.score!=null) html += '<span class="qc-dot qc-dot-score" style="left:'+left+';top:'+yOf(pd.score).toFixed(1)+'%"></span>';
  if(pd.pass!=null) html += '<span class="qc-dot qc-dot-pass" style="left:'+left+';top:'+yOf(pd.pass).toFixed(1)+'%"></span>';
  html += '</div><div class="qc-labels">';
  data.forEach(function(d, i){
    var show = data.length<=12 || i%2===(data.length-1)%2;
    html += '<span>'+(show ? MONTH_SHORT[d.m.month] : '')+'</span>';
  });
  html += '</div></div>';
  html += '<div class="chart-legend">' +
    '<span><i class="lg-line" style="background:var(--accent)"></i>Skóre</span>' +
    '<span><i class="lg-line lg-dash" style="background:var(--ok)"></i>Audity bez závad</span>' +
    '<span><i style="background:var(--ok-line)"></i><i style="background:var(--nok-line);margin-left:-2px"></i>Počet auditů OK / NOK</span></div>';
  html += '<div class="chart-pick"><b>'+esc(MONTH_NAMES_CS[pd.m.month]+' '+pd.m.year)+'</b> · '+pd.total+' audit'+dashPlural(pd.total,'','y','ů') +
    (pd.score!=null ? ' · skóre '+fmtPctCs(pd.score, 1) : '') + (pd.pass!=null ? ' · bez závad '+fmtPctCs(pd.pass, 0) : '') + '</div>';
  return html;
}

function dashCorrectiveStatusHtml(ctx){
  var list = dashItemsInPeriod(ctx);
  var c = {hotovo:0, open:0, overdue:0, zruseno:0};
  list.forEach(function(it){
    if(it.status==='hotovo') c.hotovo++;
    else if(it.status==='zruseno') c.zruseno++;
    else if(isCorrectiveOverdue(it)) c.overdue++;
    else c.open++;
  });
  if(!list.length) return dashEmptyHtml(ctx.win ? 'V tomto období žádná opatření.' : 'Zatím žádná opatření.');
  var rows = [
    ['hotovo','Hotovo',c.hotovo,'var(--ok)'], ['v_reseni','V řešení',c.open,'var(--na)'],
    ['overdue','Po termínu',c.overdue,'var(--nok)'], ['zruseno','Zrušeno',c.zruseno,'var(--fg-faint)']
  ];
  var html = '<div class="donut-wrap">' + donutHtml(rows.map(function(r){ return {value:r[2], color:r[3]}; }), list.length, 'opatření') +
    '<div class="donut-legend">';
  rows.forEach(function(r){
    html += '<button type="button" class="donut-row" onclick="App.dashOpenCorrective(\''+r[0]+'\')"><span class="lg"><i style="background:'+r[3]+'"></i>'+r[1]+'</span>' +
      '<b class="mono"'+(r[0]==='overdue'&&r[2]>0?' style="color:var(--nok)"':'')+'>'+r[2]+'</b></button>';
  });
  html += '</div></div>';
  if(ctx.win) html += '<div class="kpi-note">Opatření z auditů uzavřených ve vybraném období.</div>';
  return html;
}

function dashDisciplineHtml(ctx){
  var ds = dashDisciplineStats(ctx.items, ctx.win ? ctx.win.start : null, ctx.win ? ctx.win.end : null);
  if(!ds.resolved) return dashEmptyHtml(ctx.win ? 'V tomto období nebylo vyřešeno žádné opatření.' : 'Zatím nebylo vyřešeno žádné opatření.');
  var html = '<div class="mini-stats">' +
    '<div class="mini-stat"><div class="num mono"'+(ds.onTimeRate!=null?' style="color:'+(ds.onTimeRate>=80?'var(--ok)':(ds.onTimeRate<50?'var(--nok)':'var(--na)'))+'"':'')+'>'+fmtPctCs(ds.onTimeRate, 0)+'</div><div class="lbl">vyřešeno do termínu</div></div>' +
    '<div class="mini-stat"><div class="num mono">'+(ds.avgDays==null?'—':fmtNumCs(ds.avgDays, ds.avgDays<10?1:0)+' '+dashPlural(Math.round(ds.avgDays),'den','dny','dní'))+'</div><div class="lbl">průměrná doba vyřešení</div></div>' +
    '</div>';
  if(ds.withDue){
    var p = ds.onTime/ds.withDue*100;
    html += '<div class="split-bar"><span style="width:'+p.toFixed(1)+'%;background:var(--ok)"></span><span style="width:'+(100-p).toFixed(1)+'%;background:var(--nok-line)"></span></div>' +
      '<div class="split-bar-lbl"><span>'+ds.onTime+' v termínu</span><span>'+ds.late+' se zpožděním'+(ds.avgLateDays!=null?' (v průměru o '+Math.round(ds.avgLateDays)+' '+dashPlural(Math.round(ds.avgLateDays),'den','dny','dní')+')':'')+'</span></div>';
  }
  if(ds.resolved>ds.withDue) html += '<div class="kpi-note">'+(ds.resolved-ds.withDue)+' vyřešených bez termínu se do podílu nepočítá.</div>';
  return html;
}

var DAY_SHORT_CS = ['ne','po','út','st','čt','pá','so'];
function dashPlanHtml(ctx){
  var occ = dashPlanOccurrences(ctx), pw = dashPlanWindow(ctx);
  var ps = dashPlanStats(occ, pw.start, pw.end);
  var html = '<div class="donut-wrap">';
  var r = 34, C = 2*Math.PI*r, L = ps.rate==null ? 0 : C*ps.rate/100;
  html += '<svg class="donut" viewBox="0 0 90 90" style="width:96px;height:96px" role="img" aria-label="Plnění plánu '+esc(fmtPctCs(ps.rate,0))+'">' +
    '<circle cx="45" cy="45" r="'+r+'" fill="none" style="stroke:var(--border)" stroke-width="10" opacity=".45"/>' +
    (L>0 ? '<circle cx="45" cy="45" r="'+r+'" fill="none" style="stroke:var(--accent)" stroke-width="10" stroke-linecap="round" stroke-dasharray="'+L.toFixed(2)+' '+(C-L).toFixed(2)+'" transform="rotate(-90 45 45)"/>' : '') +
    '<text x="45" y="51" text-anchor="middle" class="donut-num">'+esc(fmtPctCs(ps.rate, 0))+'</text></svg>';
  html += '<div class="donut-legend">' +
    '<div class="donut-row static"><span class="lg">Provedeno</span><b class="mono">'+ps.done+'</b></div>' +
    '<button type="button" class="donut-row" onclick="App.dashOpenMissedPlan()"><span class="lg">Neprovedeno</span><b class="mono"'+(ps.missed?' style="color:var(--nok)"':'')+'>'+ps.missed+'</b></button>' +
    '<div class="donut-row static"><span class="lg">Termínů celkem</span><b class="mono">'+ps.due+'</b></div>' +
    '</div></div>';
  if(pw.implicit) html += '<div class="kpi-note">Za posledních 12 měsíců (bez vybraného období).</div>';
  var today = dashTodayStart(), lim = new Date(today.getTime()); lim.setDate(lim.getDate()+15);
  var upcoming = occ.filter(function(o){ return !o.fulfilled && o.date>=today && o.date<lim; });
  html += '<div class="list-sep"></div><div class="muted" style="font-size:var(--fs-sm);margin-bottom:4px">Příštích 14 dní · '+upcoming.length+' '+dashPlural(upcoming.length,'termín','termíny','termínů')+'</div>';
  upcoming.slice(0, 3).forEach(function(o){
    html += '<div class="row-between plan-up"><span class="plan-up-name"><b>'+esc(o.workplaceName)+'</b> <span class="muted">· '+esc(o.scheduleName||o.auditTypeName)+'</span></span>' +
      '<span class="mono muted" style="flex-shrink:0">'+DAY_SHORT_CS[o.date.getDay()]+' '+o.date.getDate()+'. '+(o.date.getMonth()+1)+'.</span></div>';
  });
  html += '<button type="button" class="link-btn" style="margin-top:6px" onclick="App.setView(\'schedule\')">'+(upcoming.length>3 ? '+ '+(upcoming.length-3)+' dalších · ' : '')+'Zobrazit plán →</button>';
  return html;
}

function dashAreasHtml(ctx){
  var map = new Map();
  ctx.filtered.forEach(function(e){
    (e[1].answers||[]).forEach(function(ans){
      if(ans.result!=='OK' && ans.result!=='NOK') return;
      var key = ans.groupId || ans.groupName || '—';
      var g = map.get(key);
      if(!g){ g = {key:key, name:ans.groupName||'Bez skupiny', ok:0, nok:0, q:new Map()}; map.set(key, g); }
      if(ans.result==='OK') g.ok++; else g.nok++;
      var qk = ans.questionId || ans.questionText;
      var q = g.q.get(qk);
      if(!q){ q = {text:ans.questionText, total:0, nok:0}; g.q.set(qk, q); }
      q.total++; if(ans.result==='NOK') q.nok++;
    });
  });
  var list = Array.from(map.values()).filter(function(g){ return g.nok>0; })
    .map(function(g){ g.rate = g.nok/(g.ok+g.nok)*100; return g; })
    .sort(function(a,b){ return b.rate-a.rate || b.nok-a.nok; });
  if(!list.length) return dashEmptyHtml('Žádné NOK odpovědi v tomto výběru.');
  var maxRate = list[0].rate || 1, th = dashScoreThresholds(ctx);
  var html = '<div class="kpi-note" style="margin:-4px 0 8px">Skupiny otázek podle podílu NOK odpovědí</div>';
  dashboardLimitList(list, 'areas').forEach(function(g){
    var color = scorePercentColor(Math.round(100-g.rate), th);
    var open = state.dashAreaOpen===g.key;
    html += '<button type="button" class="hbar-row" onclick="App.dashToggleArea('+jsArg(g.key)+')" aria-expanded="'+open+'">' +
      '<span class="hbar-head"><span class="hbar-name">'+esc(g.name)+'</span><b class="mono" style="color:'+color+'">'+fmtPctCs(g.rate, 0)+'</b></span>' +
      '<span class="hbar-bg"><span style="width:'+(g.rate/maxRate*100).toFixed(1)+'%;background:'+color+'"></span></span></button>';
    if(open){
      var qs = Array.from(g.q.values()).filter(function(q){ return q.nok>0; }).sort(function(a,b){ return b.nok-a.nok; }).slice(0,3);
      html += '<div class="hbar-detail">' + qs.map(function(q){
        return '<div class="row-between" style="gap:8px;align-items:flex-start"><span>'+esc(q.text||'')+'</span><span class="mono" style="flex-shrink:0;color:var(--nok);font-weight:600">'+q.nok+'× z '+q.total+'</span></div>';
      }).join('') + '</div>';
    }
  });
  return html;
}

function dashHeatmapHtml(ctx){
  var n = ctx.cfg.limits.heatmap || 6;
  var months = dashMonthBuckets(n);
  var from = months[0].start, to = months[months.length-1].end;
  var rows = new Map();
  ctx.filteredNoPeriod.forEach(function(e){
    var a = e[1];
    if(!a.closedAt) return;
    var d = new Date(a.closedAt);
    if(d<from || d>=to) return;
    var r = rows.get(a.workplaceId);
    if(!r){
      var w = state.workplaces.get(a.workplaceId);
      r = {id:a.workplaceId, name:(w&&workplaceLabel(w))||a.workplaceName||'—', cells:{}};
      rows.set(a.workplaceId, r);
    }
    (r.cells[monthKeyOf(d)] || (r.cells[monthKeyOf(d)] = [])).push(e);
  });
  if(!rows.size) return dashEmptyHtml('Za '+n+' měsíců žádné uzavřené audity.');
  var th = dashScoreThresholds(ctx);
  var list = Array.from(rows.values()).map(function(r){
    var vals = [];
    r.vals = months.map(function(m){
      var l = r.cells[m.key];
      if(!l) return null;
      var v = auditsScore(l); if(v==null) v = auditsPassRate(l);
      if(v!=null) vals.push(v);
      return v;
    });
    r.avg = vals.length ? vals.reduce(function(s,v){ return s+v; }, 0)/vals.length : 101;
    return r;
  }).sort(function(a,b){ return a.avg-b.avg || a.name.localeCompare(b.name,'cs'); });
  var MAX_ROWS = 12;
  var sym = appearance.colorblindMode && n<=6;
  var html = '<div class="kpi-note" style="margin:-4px 0 8px">Skóre auditů po měsících, nejhorší nahoře</div>' +
    '<div class="hm" style="grid-template-columns:minmax(72px,2.2fr) repeat('+n+',minmax(0,1fr))"><span></span>' +
    months.map(function(m){ return '<span class="hm-hd">'+MONTH_SHORT[m.month]+'</span>'; }).join('');
  list.slice(0, MAX_ROWS).forEach(function(r){
    html += '<button type="button" class="hm-name" onclick="App.goHistoryWp(\''+esc(r.id)+'\')" title="'+esc(r.name)+'"><span>'+esc(r.name)+'</span></button>';
    r.vals.forEach(function(v, i){
      var z = dashScoreZone(v==null?null:Math.round(v), th);
      html += '<span class="hm-c hm-'+z+' mono" title="'+esc(r.name+' · '+MONTH_NAMES_CS[months[i].month]+(v==null?' · bez auditu':' · '+fmtPctCs(v,0)))+'">' +
        (v==null ? '–' : (sym ? SCORE_ZONE_SYMBOLS[z==='good'?'good':(z==='bad'?'bad':'warn')]+' ' : '')+Math.round(v)) + '</span>';
    });
  });
  html += '</div>';
  if(list.length>MAX_ROWS) html += '<div class="kpi-note">+ '+(list.length-MAX_ROWS)+' dalších pracovišť (vyberte pracoviště ve Filtrech).</div>';
  html += '<div class="chart-legend"><span><i class="hm-good"></i>'+th.good+' % a víc</span><span><i class="hm-warn"></i>'+th.bad+'–'+(th.good-1)+' %</span>' +
    '<span><i class="hm-bad"></i>pod '+th.bad+' %</span><span><i class="hm-empty"></i>bez auditu</span></div>';
  return html;
}

function dashCorrectiveFlowHtml(ctx){
  var n = ctx.cfg.limits.correctiveFlow || 6;
  var months = dashMonthBuckets(n);
  var nowT = ctx.now.getTime();
  var data = months.map(function(m, i){
    var s = m.start.getTime(), e = m.end.getTime();
    var created = 0, resolved = 0;
    ctx.items.forEach(function(it){
      var c = it.closedAt ? new Date(it.closedAt).getTime() : null;
      if(c!=null && c>=s && c<e) created++;
      var r = correctiveResolvedAt(it);
      if(r){ var rt = new Date(r).getTime(); if(rt>=s && rt<e) resolved++; }
    });
    var t = Math.min(e, nowT);
    var backlog = ctx.items.filter(function(it){ return correctiveOpenAt(it, t); }).length;
    return {m:m, created:created, resolved:resolved, backlog:backlog};
  });
  var startBacklog = ctx.items.filter(function(it){ return correctiveOpenAt(it, months[0].start.getTime()-1); }).length;
  if(!data.some(function(d){ return d.created || d.resolved || d.backlog; }) && !startBacklog) return dashEmptyHtml('Za '+n+' měsíců žádná opatření.');
  var maxBar = Math.max.apply(null, data.map(function(d){ return Math.max(d.created, d.resolved); })) || 1;
  var maxBl = Math.max.apply(null, data.map(function(d){ return d.backlog; }).concat([startBacklog])) || 1;
  function yBl(v){ return 100 - v/maxBl*80 - 8; }
  var html = '<div class="qc noaxis"><div class="qc-area"><div class="qc-grid qc-grid-base" style="top:100%"></div><div class="qc-cols">';
  data.forEach(function(d){
    html += '<div class="qc-col qc-pair" title="'+esc(MONTH_NAMES_CS[d.m.month]+': nových '+d.created+', vyřešených '+d.resolved+', nevyřešených '+d.backlog)+'">' +
      '<span class="qc-bar qc-bar-new" style="height:'+(d.created/maxBar*62).toFixed(1)+'%"></span>' +
      '<span class="qc-bar qc-bar-res" style="height:'+(d.resolved/maxBar*62).toFixed(1)+'%"></span></div>';
  });
  html += '</div><svg class="qc-lines" viewBox="0 0 '+(data.length*10)+' 100" preserveAspectRatio="none" aria-hidden="true"><polyline class="qc-line-backlog" points="' +
    data.map(function(d, i){ return ((i+.5)*10).toFixed(1)+','+yBl(d.backlog).toFixed(1); }).join(' ')+'"/></svg>';
  var first = data[0], last = data[data.length-1];
  html += '<span class="qc-val" style="left:'+(.5/data.length*100).toFixed(2)+'%;top:'+yBl(first.backlog).toFixed(1)+'%">'+first.backlog+'</span>';
  if(data.length>1) html += '<span class="qc-val" style="left:'+((data.length-.5)/data.length*100).toFixed(2)+'%;top:'+yBl(last.backlog).toFixed(1)+'%">'+last.backlog+'</span>';
  html += '</div><div class="qc-labels">' + data.map(function(d){ return '<span>'+MONTH_SHORT[d.m.month]+'</span>'; }).join('') + '</div></div>';
  html += '<div class="chart-legend"><span><i style="background:var(--na)"></i>Nová</span><span><i style="background:var(--ok)"></i>Vyřešená</span>' +
    '<span><i class="lg-line" style="background:var(--fg)"></i>Nevyřešená celkem</span></div>';
  var diff = last.backlog - startBacklog;
  var cls = diff<0 ? 'good' : (diff>0 ? 'bad' : '');
  var txt = diff<0 ? 'Nevyřešených ubývá: za '+n+' '+dashPlural(n,'měsíc','měsíce','měsíců')+' z '+startBacklog+' na '+last.backlog+'.' :
    (diff>0 ? 'Nevyřešených přibývá: za '+n+' '+dashPlural(n,'měsíc','měsíce','měsíců')+' z '+startBacklog+' na '+last.backlog+'.' : 'Počet nevyřešených se nemění ('+last.backlog+').');
  html += '<div class="chart-pick '+cls+'">'+txt+'</div>';
  return html;
}

function dashCorrectiveAgingHtml(ctx){
  var open = ctx.items.filter(isCorrectiveOpen);
  if(!open.length) return dashEmptyHtml('Žádná otevřená opatření.');
  var b = [0,0,0,0], nowT = ctx.now.getTime();
  open.forEach(function(it){
    var d = it.closedAt ? dashDays(nowT-new Date(it.closedAt).getTime()) : 0;
    b[d<=30?0:(d<=60?1:(d<=90?2:3))]++;
  });
  var mx = Math.max.apply(null, b) || 1;
  var colors = ['var(--ok-line)','var(--na-line)','var(--nok-line)','var(--nok)'];
  var labels = ['0–30 dní','31–60','61–90','90+ dní'];
  var html = '<div class="vbars">';
  b.forEach(function(v, i){
    html += '<div class="vbar"><b class="mono"'+(i===3&&v>0?' style="color:var(--nok)"':'')+'>'+v+'</b><span style="height:'+Math.max(v/mx*100, v?6:2).toFixed(1)+'%;background:'+colors[i]+'"></span></div>';
  });
  html += '</div><div class="vbar-labels">'+labels.map(function(l){ return '<span>'+l+'</span>'; }).join('')+'</div>';
  html += '<div class="kpi-note">Od uzavření auditu, ve kterém opatření vzniklo.</div>';
  return html;
}

function dashResponsibleHtml(ctx){
  var map = new Map();
  ctx.items.forEach(function(it){
    if(!isCorrectiveOpen(it)) return;
    var name = (it.responsible||'').trim();
    var r = map.get(name);
    if(!r){ r = {name:name, open:0, overdue:0, wps:{}}; map.set(name, r); }
    r.open++;
    if(isCorrectiveOverdue(it)) r.overdue++;
    if(it.workplaceName) r.wps[it.workplaceName] = true;
  });
  if(!map.size) return dashEmptyHtml('Žádná otevřená opatření.');
  var list = Array.from(map.values()).sort(function(a,b){ return b.overdue-a.overdue || b.open-a.open || a.name.localeCompare(b.name,'cs'); });
  var html = '<div class="kpi-note" style="margin:-4px 0 6px">Nejvíc otevřených opatření</div>';
  dashboardLimitList(list, 'responsible').forEach(function(r, i){
    var wps = Object.keys(r.wps);
    html += (i>0?'<div class="list-sep"></div>':'') +
      '<button type="button" class="resp-row" onclick="App.dashOpenCorrective(\'v_reseni\', '+jsArg(r.name)+')">' +
      '<span style="min-width:0"><span class="resp-name">'+esc(r.name||'Bez odpovědné osoby')+'</span>' +
      '<span class="resp-sub">'+esc(wps.slice(0,2).join(', ')+(wps.length>2?' a další':''))+'</span></span>' +
      '<span class="resp-badges"><span class="badge badge-na">'+r.open+' '+dashPlural(r.open,'otevřené','otevřená','otevřených')+'</span>' +
      (r.overdue ? '<span class="badge badge-nok">'+r.overdue+' po termínu</span>' : '') + '</span></button>';
  });
  return html;
}

function dashBranchesHtml(ctx){
  var map = new Map();
  ctx.filtered.forEach(function(e){
    var a = e[1];
    var bid = workplaceBranchId(a.workplaceId) || a.branchId || '';
    (map.get(bid) || (map.set(bid, []), map.get(bid))).push(e);
  });
  if(!map.size) return dashEmptyHtml('V tomto výběru žádné uzavřené audity.');
  var th = dashScoreThresholds(ctx);
  var list = Array.from(map.entries()).map(function(en){
    var sc = auditsScore(en[1]), pr = sc==null ? auditsPassRate(en[1]) : null;
    return {id:en[0], name:branchLabel(en[0]), count:en[1].length, val: sc!=null ? sc : pr, isPass: sc==null && pr!=null};
  }).sort(function(a,b){ return (b.val==null?-1:b.val)-(a.val==null?-1:a.val) || a.name.localeCompare(b.name,'cs'); });
  var html = '';
  list.forEach(function(b){
    var color = b.val==null ? 'var(--fg-faint)' : scorePercentColor(Math.round(b.val), th);
    html += '<button type="button" class="hbar-row" onclick="App.setDashboardFilterBranch('+jsArg(b.id)+')" title="Zobrazit Přehled jen pro tuto provozovnu">' +
      '<span class="hbar-head"><span class="hbar-name">'+esc(b.name)+'</span><span class="mono"><b style="color:'+color+'">'+(b.val==null?'—':fmtPctCs(b.val, 0)+(b.isPass?' OK':''))+'</b> <span class="muted">· '+b.count+' audit'+dashPlural(b.count,'','y','ů')+'</span></span></span>' +
      '<span class="hbar-bg"><span style="width:'+(b.val||0).toFixed(1)+'%;background:'+color+'"></span></span></button>';
  });
  html += '<div class="kpi-note">Skóre · klepnutím se Přehled omezí na provozovnu.</div>';
  return html;
}

// Returns the inner HTML of one dashboard tile (no heading, no wrapping
// .dash-tile div) — shared by the real Dashboard and the Dashboard settings
// live preview, so a tile always renders identically in both places.
function dashboardTileBody(id, ctx){
  var cfg = ctx.cfg;
  if(DASHBOARD_KPI_IDS.indexOf(id)>=0) return dashKpiTileHtml(id, ctx);
  if(dashGroup(id)) return dashGroupBodyHtml(id, ctx);
  if(id==='trend') return dashTrendHtml(ctx);
  if(id==='correctiveStatus') return dashCorrectiveStatusHtml(ctx);
  if(id==='correctiveDiscipline') return dashDisciplineHtml(ctx);
  if(id==='plan') return dashPlanHtml(ctx);
  if(id==='areas') return dashAreasHtml(ctx);
  if(id==='heatmap') return dashHeatmapHtml(ctx);
  if(id==='correctiveFlow') return dashCorrectiveFlowHtml(ctx);
  if(id==='correctiveAging') return dashCorrectiveAgingHtml(ctx);
  if(id==='responsible') return dashResponsibleHtml(ctx);
  if(id==='branches') return dashBranchesHtml(ctx);
  if(id==='workplaces'){
    var wpList = dashboardLimitList(worstFirst(ctx.wpStats), 'workplaces');
    if(wpList.length===0) return '<div class="muted" style="font-size:var(--fs-base)">Žádná pracoviště neodpovídají filtru.</div>';
    return wpList.map(function(e){ return statCardHtml(e[0], e[1], {showOverdue:true, onclick:"App.goHistoryWp('"+e[0]+"')", plain:true}); }).join('');
  }
  if(id==='types'){
    var typeList = dashboardLimitList(worstFirst(ctx.typeStats), 'types');
    if(typeList.length===0) return '<div class="muted" style="font-size:var(--fs-base)">Žádné druhy auditů neodpovídají filtru.</div>';
    return typeList.map(function(e){ return statCardHtml(e[0], e[1], {showOverdue:false, onclick:"App.goHistoryType('"+e[0]+"')", plain:true, isType:true}); }).join('');
  }
  if(id==='failing'){
    var failing = computeFailingQuestions(cfg.limits.failing||6, ctx.filtered);
    if(failing.length===0) return '<div class="muted" style="font-size:var(--fs-base)">Zatím žádné opakující se problémy.</div>';
    return failing.map(function(q,i){
      var rate = Math.round(q.nok/q.total*100);
      return (i>0?'<div class="list-sep"></div>':'') +
        '<div class="row-between" style="align-items:flex-start;gap:10px">' +
        '<div style="min-width:0"><div style="font-size:var(--fs-md);font-weight:500">'+esc(q.text)+'</div>' +
        '<div class="muted" style="font-size:var(--fs-sm);margin-top:2px">'+esc(q.groupName||'')+'</div></div>' +
        '<div style="text-align:right;flex-shrink:0"><div class="mono" style="font-weight:700;color:var(--nok);font-size:var(--fs-md)">'+q.nok+'×</div>' +
        '<div class="muted" style="font-size:var(--fs-sm)">z '+q.total+' · '+rate+'%</div></div></div>';
    }).join('');
  }
  if(id==='auditors'){
    var auditors = dashboardLimitList(computeAuditorStats(ctx.filtered), 'auditors');
    if(auditors.length===0) return '<div class="muted" style="font-size:var(--fs-base)">Zatím žádné uzavřené audity.</div>';
    return auditors.map(function(s,i){
      var rate = s.okNokTotal? Math.round(s.okCount/s.okNokTotal*100) : null;
      return (i>0?'<div class="list-sep"></div>':'') +
        '<div class="row-between">' +
        '<div style="min-width:0"><div style="font-size:var(--fs-md);font-weight:600">'+esc(s.name)+'</div>' +
        '<div class="muted" style="font-size:var(--fs-sm);margin-top:2px">'+s.total+' audit'+(s.total===1?'':(s.total>=2&&s.total<=4?'y':'ů')) +
        ' · naposledy '+fmtDateShort(s.lastClosedAt)+'</div></div>' +
        '<div style="text-align:right;flex-shrink:0"><div class="mono" style="font-weight:700;font-size:var(--fs-md)">'+(rate==null?'—':rate+'%')+'</div>' +
        '<div class="muted" style="font-size:var(--fs-sm)">'+s.nokSum+' NOK celkem</div></div></div>';
    }).join('');
  }
  return '';
}

export {
  dashKpiTileHtml,
  buildDashboardCtx,
  correctiveResolvedAt,
  dashGroupBodyHtml,
  dashGroupMembers,
  dashboardSectionApplicable,
  dashboardTileApplicable,
  dashboardTileBody,
  dashboardTileHeading,
  daysSince,
  workplaceBranchId
};
